import React from "react";
import { Link } from "react-router-dom";
import invoiceLogo from "../assets/up-icons/invoice.png";
import pdfLogo from "../assets/up-icons/pdf.png";

const HomePage = () => {
  return (
    <div className="flex flex-col">
      {/* Hero Section */}
      <header className="bg-white/20 text-color">
        <div className="container mx-auto px-4 py-16 text-center">
          <h1 className="text-5xl font-luthier font-bold">Tools by UP-Hub</h1>
        </div>
      </header>

      {/* App Links Section */}
      <main className="container mx-auto px-4 py-12 flex-1">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Invoice Generator */}
          <Link
            to="/invoice-menu"
            className="custom-card p-6 text-center hover:bg-white/20 hover:border-dark-alt hover:shadow-xl transition"
          >
            <div className="flex justify-center mb-4">
              <img
                src={invoiceLogo}
                alt="Invoice logo"
                className="h-36 w-auto"
              />
            </div>
            <h3 className="text-2xl font-bold mb-2">Invoice Generator</h3>
            <div className="custom-divider"></div>
            <p className="text-alt-color">
              Instantly create professional documents with easy-to-use templates
              for invoices, receipts, and transmittal letters with easy to edit
              headers to display your company branding.
            </p>
          </Link>

          {/* PDF Editor */}
          <Link
            to="/pdf"
            className="custom-card p-6 text-center hover:bg-white/20 hover:border-dark-alt hover:shadow-xl transition"
          >
            <div className="flex justify-center mb-4">
              <img src={pdfLogo} alt="PDF Logo" className="h-36 w-auto" />
            </div>
            <h3 className="text-2xl font-bold mb-2">PDF Editor</h3>
            <div className="custom-divider"></div>
            <p className="text-alt-color">
              Our SmartPDF Editor is a powerful, all-in-one tool for editing,
              converting, and managing PDFs effortlessly. Whether you need to
              add/modify text, or make a fill- forms, this dynamic editor makes
              it quick and hassle-free.
            </p>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default HomePage;
